import React from "react";
import SPDXLicenses from "../../../../../data/SPDXLicenses";

import s from "./Authors.module.scss";

export default function Authors({ product = {} }) {
	const authors = (product.authors || []).map((a) => a.name).join("; ");

	const license = SPDXLicenses.find((ll) => ll.licenseId === product.licenseId);

	return (
		<div className={s.root}>
			{authors && (
				<div>
					<div className={s.title}>Authors</div>
					<p className={s.authors}>{authors}</p>
				</div>
			)}

			{license && (
				<div>
					<div className={s.title}>License:</div>
					<a
						className={s.license}
						href={license.reference}
						rel="noreferrer"
						target="_blank"
					>
						<p className={s.license}>{license?.name}</p>
					</a>
				</div>
			)}
		</div>
	);
}
